<template>
  <b-col class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <div>
              <b-row>
                <b-col sm="3">
                  <i class="fa fa-bars"></i> {{ $t('str.user') }}
                </b-col>
                <b-col sm="9"></b-col>
              </b-row>
            </div>

            <div>
              <b-row style="margin-top:10px;">
                <b-col sm="12">
                  <b-row>
                    <b-col sm="6">Keyword</b-col>
                    <b-col sm="3">Country</b-col>
                    <b-col sm="3"></b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6">
                      <b-form-input id="keyword" class="form-control" type="text" name="keyword"
                        :placeholder="$t('str.search')" v-model="keyword" @keyup.enter="getList()"></b-form-input>
                    </b-col>
                    <b-col sm="3">
                      <b-form-select id="country" name="country_code" :plain="true" v-model="country_code"
                        style="height:100%;">
                        <option value="">All</option>
                        <option v-for="(c, index) in countrySelect" :value="c.value" :key="index">{{c.text}}</option>
                      </b-form-select>
                    </b-col>
                    <b-col sm="3">
                      <buttons button-type="search" @click="getList()" />&nbsp;
                      <buttons button-type="reset_filter" @click="resetFilter()" />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row style="margin-top:10px;">
                <b-col sm="12">
                  <b-row>
                    <b-col sm="9"></b-col>
                    <b-col sm="3"></b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="9"></b-col>
                    <b-col sm="3">
                      <buttons button-type="export" :exporting="submittedExport" @click="exportFile()" />&nbsp;
                      <router-link to="/account/user/manage/0" class="card-header-action btn-setting">
                        <buttons button-type="add_new" />
                      </router-link>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>

          <p :class="{'text-center':true, 'd-none':items.length}" class="">{{ $t('str.no-data') }}</p>
          <b-table :class="{'d-none':!items.length}" :hover="hover" :striped="striped" :bordered="bordered"
            :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
            <template slot="action" slot-scope="data">
              <router-link :to="'/account/user/manage/'+data.item.id">
                <buttons button-type="edit" />
              </router-link>
              <template v-if="data.item.status == 'unconfirmed' && btnHide.includes(data.item.id)">
                &nbsp;
                <b-button variant="warning" size="sm" @click="confirmUser(data.item.id)">
                  <i class="fa fa-check-circle"></i>&nbsp;{{ $t('str.confirm') }}
                </b-button>
              </template>
              &nbsp;
              <buttons button-type="delete" @click="confirmDelete(data.item.id)" />
            </template>
          </b-table>
          <nav :class="{'d-none':!items.length}">
            <paging :current-page="currentPage" :total-pages="totalPage" @page-changed="pageOneChanged" prev-text="Prev"
              next-text="Next" />
          </nav>
        </b-card>
      </b-col>
    </b-row>
    <confirm-modal :item="confirmDeleteId" @confirm="deleteUser" @cancel="cancelDelete"></confirm-modal>
  </b-col>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

import Pagination from '@/views/component/Pagination'
import ConfirmModal from '@/views/component/ConfirmModal'
import Buttons from '@/views/component/Buttons'

export default {
  name: 'User',
  components: {
    'paging': Pagination,
    'confirm-modal': ConfirmModal,
    'buttons': Buttons
  },
  props: {
    hover: { type: Boolean, default: false },
    striped: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    fixed: { type: Boolean, default: false }
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'first_name', sortable: true },
        { key: 'last_name', sortable: true },
        { key: 'email', sortable: true },
        { key: 'country_name', label: 'Country', sortable: true },
        {
          key: 'created_at', label: 'Registered', sortable: true, formatter: (value, key, item) => {
            var dateTime = new Date(item.created_at)
            dateTime = moment(dateTime).format("YYYY-MM-DD HH:mm:ss")
            return dateTime
          }
        },
        { key: 'action' }
      ],
      keyword: '',
      currentPage: 1,
      totalPage: 0,
      confirmModal: false,
      confirmDeleteId: '',
      country_code: '',
      countrySelect: [],
      submittedExport: false,
      btnHide: [],
    }
  },
  methods: {
    async getCountrySelect() {
      this.$auth.checkSession()
      try {
        let url = `${this.$helper.envi.VUE_APP_API_URL}/User/Country`

        let getData = await axios.get(url, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        let cData = getData.data.data

        for (var i = 0; i < cData.length; i++) {
          this.countrySelect.push({ 'value': cData[i].code, 'text': cData[i].name })
        }
      } catch (e) {
        console.log(e.response)
      }
    },
    async getList(page) {
      this.$auth.checkSession()
      var trail = `?limit=${this.$helper.envi.VUE_APP_PAGING_LIMIT}`
      if (page) trail = `${trail}&page=${page}`
      if (this.keyword != '') trail = `${trail}&keyword=${this.keyword}`
      if (this.country_code != '') trail = `${trail}&country_code=${this.country_code}`

      try {
        var getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/User${trail}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.items = getData.data.data
        this.currentPage = getData.data.meta.page
        this.totalPage = getData.data.meta.pageCount

        this.btnHide = []
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].status == 'unconfirmed')
            this.btnHide.push(this.items[i].id)
        }
        console.log(this.btnHide)
      } catch (e) {
        console.log(e.response)
      }
    },
    async deleteUser(id) {
      this.$auth.checkSession()
      try {
        var result = await axios.delete(`${this.$helper.envi.VUE_APP_API_URL}/User/${id}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.$toast.success(result.data.meta.message, '', {
          position: 'topCenter'
        })

        this.getList()
        this.confirmModal = false
      } catch (e) {
        console.log(e.response)
      }
    },
    async confirmUser(id) {
      this.$auth.checkSession()
      try {
        var result = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/User/${id}/Confirm`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.$toast.success(result.data.meta.message, '', {
          position: 'topCenter'
        })

        this.btnHide = this.btnHide.filter(function (e) { return e !== id })

        // this.getList()
      } catch (e) {
        console.log(e.response)
      }
    },
    async exportFile() {
      this.exportFileSuccess = ''
      this.exportFileError = ''
      this.$auth.checkSession()

      let trail = `?`
      if (this.keyword != '') trail = `${trail}&keyword=${this.keyword}`
      if (this.country_code != '') trail = `${trail}&country_code=${this.country_code}`

      let url = `${this.$helper.envi.VUE_APP_API_URL}/Export/User` + trail

      try {
        this.submittedExport = true
        let file = await axios.get(url, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })
        if (file.data) {
          window.open(this.$helper.envi.VUE_APP_API_URL + '/' + file.data)
        }

        let delUrl = this.$helper.envi.VUE_APP_API_URL + '/Export/DownloadFile/User'
        let delAuth = this.$auth.session.get().passport
        let timer = setInterval(async function () {
          if (open.closed) {
            clearInterval(timer)
            await axios.get(delUrl, {
              headers: { 'Authorization': `Bearer ${delAuth}` }
            })
          }
        }, 1000)
      } catch (e) { console.log(e) }
      this.submittedExport = false
    },
    resetFilter() {
      this.keyword = ''
      this.country_code = ''
      this.getCountrySelect()
      this.getList()
    },
    pageOneChanged(pageNum) {
      this.$auth.checkSession()
      this.currentPage = pageNum
      this.getList(pageNum)
    },
    confirmDelete(id) {
      this.$auth.checkSession()
      this.confirmModal = true
      this.confirmDeleteId = id
    },
    cancelDelete() {
      this.$auth.checkSession()
      this.confirmModal = false
    }
  },
  created() {
    this.getCountrySelect()
    this.getList()
  }
}
</script>